import React, { forwardRef } from 'react'
import '../css/MainMenu.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';

const MainMenu = forwardRef(({ handleClick }, ref) => {
    return (
        <div ref={ref} className='md:hidden absolute top-[10px] left-[15px] text-[20px] pointer z-[9999]' onClick={handleClick}>
            <FontAwesomeIcon icon={faBars} id="hamburger-img"/>
        </div>
    )
});

export default MainMenu